import { combineReducers } from 'redux';
import { DarkModeReducer } from 'Redux/reducers/darkModeReducer';

export default combineReducers({ DarkModeReducer });
